import React from 'react'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import SearchField from 'components/atoms/SearchField'

export default function SessionsSearchBar({
  label,
  filteredLabel,
  cars,
  filteredCars,
  query,
  handleChangeSearch,
  id,
}) {
  const { t } = useTranslation()

  return (
    <>
      <SearchField
        data-testid={`search-${id}`}
        placeholder={t('common.form.searchBy')}
        value={query}
        onChange={handleChangeSearch}
      />
      <Box pr={2} />
      <Box>
        <Stack direction="row" alignItems="center">
          <Typography
            variant="body2"
            color="textPrimary"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {label} <strong>{cars?.length} </strong>
          </Typography>
          {cars?.length !== filteredCars?.length && (
            <>
              <Box pr={1} />
              <Typography
                variant="body2"
                color="textPrimary"
                sx={{ whiteSpace: 'nowrap' }}
              >
                {filteredLabel} <strong>{filteredCars?.length}</strong>
              </Typography>
            </>
          )}
        </Stack>
        <Typography
          variant="body2"
          color="textPrimary"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {t('common.vatIncludedPricesDisclaimer')}
        </Typography>
      </Box>
    </>
  )
}

SessionsSearchBar.propTypes = {
  label: T.string,
  filteredLabel: T.string,
  cars: T.array.isRequired,
  filteredCars: T.array.isRequired,
  query: T.string,
  handleChangeSearch: T.func,
}
